
import { useEffect, useState } from "react";
import AppConst from "../apis/appconst";
import axios from "axios";
import jsPDF from 'jspdf';
import { toast } from "react-toastify";
function DeathCert() {
    const [ldata, setLdata] = useState(null);
       const [image, setImage] = useState('')
          const [showModal, setShowModal] = useState(false);
           const [dropdownOpenIndex, setDropdownOpenIndex] = useState(null);
                     const [watermarkImage, setWatermarkImage] = useState('');
                     const [footerImage, setFooterImage] = useState('');
                     const [isAdmin , setIsAdmin] = useState('')
    const [formData, setFormData] = useState({
        l1: [],
        doc: [],
        page_no: 0,
        cert_id: '',
        cert_dc_number: '',
        cert_dod: '',
        cert_type: 'death',
        cert_ipd_number: '',
        cert_patient_name: '',
        cert_guardien: '',
        cert_address: '',
        cert_city: '',
        cert_state: '',
        cert_pincode: '',
        cert_doctor: '',
        cert_mobile: '',
        cert_issued: '',
        cert_case: '',
        cert_attandant: '',
        cert_user: '',
        page_no: 0,
        alertMsg: '',
        alertMsgTyp: '',
        search_key: '',
        isAlert: false,
    });

    const handleChange = (e) => {

        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        if ((name + "").localeCompare("search_key") == 0) {
            initData();
        }
    };

    const handleChange1 = (e, index) => {
        if (!e || !e.target) return;
        const { name, value } = e.target;
        // alert(name+"");
        const name1 = name.replace(/[0-9]/g, "");

        // alert(name1+"");
        setFormData(prev => {
            const updatedItems = [...prev.medicines];
            updatedItems[index] = {
                ...updatedItems[index],
                [name1]: value
            };

            return {
                ...prev,
                medicines: updatedItems
            };
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        // alert(formData.email+"");
        const fd = new FormData();

        // purchase_type
        fd.append('cert_id', formData.cert_id);
        fd.append('cert_type', formData.cert_type);
        fd.append('cert_dc_number', formData.cert_dc_number);
        fd.append('cert_dod', formData.cert_dod);
        fd.append('cert_ipd_number', formData.cert_ipd_number);
        fd.append('cert_patient_name', formData.cert_patient_name);
        fd.append('cert_guardien', formData.cert_guardien);
        fd.append('cert_address', formData.cert_address);
        fd.append('cert_city', formData.cert_city);
        fd.append('cert_state', formData.cert_state);
        fd.append('cert_pincode', formData.cert_pincode);
        fd.append('cert_doctor', formData.cert_doctor);
        fd.append('cert_mobile', formData.cert_mobile);
        fd.append('cert_issued', formData.cert_issued);
        fd.append('cert_case', formData.cert_case);
        fd.append('cert_attandant', formData.cert_attandant);
        fd.append('cert_user', ldata.user_id);

        try {
            const response = await axios.post(AppConst.BASE_URL + AppConst.addCertUrl, fd, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            if (response.data.status) {
                setFormData(prev => ({
                    ...prev,
                    cert_id: '',
                    cert_dc_number: '',
                    cert_dod: '',
                    cert_ipd_number: '',
                    cert_patient_name: '',
                    cert_guardien: '',
                    cert_address: '',
                    cert_city: '',
                    cert_state: '',
                    cert_pincode: '',
                    cert_doctor: '',
                    cert_mobile: '',
                    cert_issued: '',
                    cert_case: '',
                    cert_attandant: '',
                    cert_user: '',
                    isAlert: true,
                    alertMsg: response.data.success,
                    alertMsgTyp: response.data.type,
                }));
                initData();
            }
            else {
                setFormData(prev => ({
                    ...prev,
                    isAlert: true,
                    alertMsg: response.data.success,
                    alertMsgTyp: response.data.type,
                }));
            }
        } catch (error) {
            setFormData(prev => ({
                ...prev,
                isAlert: true,
                alertMsg: "Failed",
                alertMsgTyp: "danger",
            }));
        }

    };

    const initData = async () => {
        const storedData = sessionStorage.getItem("ldata");
          const userData = JSON.parse(sessionStorage.getItem("ldata"));
  const roleId = userData?.role_id;
    if (roleId === 1 || roleId === "1") {
      setIsAdmin(true);
    } else {
      setIsAdmin(false);
    }
        if (storedData) {
            const parsed = JSON.parse(storedData);
            const fd = new FormData();
            fd.append('page_no', formData.page_no + "");
            fd.append('search_key', formData.search_key + "");
            fd.append('cert_user', 1 + "");
            fd.append('cert_type', formData.cert_type + "");
            try {
                const response = await axios.post(AppConst.BASE_URL + AppConst.getCertListUrl, fd, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                if (response.data.status) {

                    var records = response.data.records;
                    if (records != null && records != undefined) {
                        setFormData(prev => ({
                            ...prev,
                            l1: records
                        }));
                    }
                }
            } catch (error) {

            }
        }
    };


      const initData2 = async () => {
              const storedData = sessionStorage.getItem("ldata");
              if (storedData) {
                const parsed = JSON.parse(storedData);
                const fd = new FormData();
                fd.append('type', "doctor");
                fd.append('user_cre_by', 1 + "");
          
                try {
                  const response = await axios.post(AppConst.BASE_URL + AppConst.getUserListUrl, fd, {
                    headers: {
                      'Content-Type': 'multipart/form-data',
                    },
                  });
                  console.log("Doctor List Response:", JSON.stringify(response));
                  if (response.data.status) {
          
                    var records = response.data.records;
                    if (records != null && records != undefined) {
                      setFormData(prev => ({
                        ...prev,
                        doc: records
                      }));
                    }
                  }
                } catch (error) {
          
                }
          
                
              }
            };
    const setEditItem = (tmp) => {
        setFormData(prev => ({
            ...prev,
            cert_id: tmp.cert_id,
            cert_type: tmp.cert_type,
            cert_dc_number: tmp.cert_dc_number,
            cert_dod: tmp.cert_dod,
            cert_ipd_number: tmp.cert_ipd_number,
            cert_patient_name: tmp.cert_patient_name,
            cert_guardien: tmp.cert_guardien,
            cert_address: tmp.cert_address,
            cert_city: tmp.cert_city,
            cert_state: tmp.cert_state,
            cert_pincode: tmp.cert_pincode,
            cert_doctor: tmp.cert_doctor,
            cert_mobile: tmp.cert_mobile,
            cert_issued: tmp.cert_issued,
            cert_case: tmp.cert_case,
            cert_attandant: tmp.cert_attandant,
            cert_user: tmp.cert_user,

        }));
    };

    const delItem = async (editItem) => {
        const fd = new FormData();
        fd.append('cert_id', editItem.cert_id + "");
        try {
            const response = await axios.post(AppConst.BASE_URL + AppConst.delCertUrl, fd, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            if (response.data.status) {
                initData();
            }
        } catch (error) {

        }
    };
    useEffect(() => {
        console.log('Component mounted');
        const storedData = sessionStorage.getItem("ldata");
        if (storedData) {
            const parsed = JSON.parse(storedData);
            setLdata(parsed);
            initData();
            initData2();
        }




        return () => {
            console.log('Component unmounted');
        };
    }, []);
          useEffect(() => {
            const random10Digit = Math.floor(1000000000 + Math.random() * 9000000000);
            setFormData(prev => ({
              ...prev,
              cert_dc_number: random10Digit.toString(),
            }));
          }, []);

            const searchUserNow = async () => {
              const uhid = (formData.cert_ipd_number || "").trim(); // cert_ipd_number hi UHID field hai
          
              if (uhid.length <= 7) {
                  toast.error("Please enter a valid UHID");
                  return;
              }
          
              try {
                  const fd = new FormData();
                  fd.append("lab_reg_uhid", uhid);
          
                  const response = await axios.post(
                      AppConst.BASE_URL + AppConst.searchUhidUrlCall,
                      fd,
                      { headers: { "Content-Type": "multipart/form-data" } }
                  );
          
                  if (response.data.status) {
                      const users = response.data.records;
                      console.log("Fetched Users:", JSON.stringify(users));
                      if (users && users.length > 0) {
                          const patient = users[0];
          
                          // Mapping UHID patient details into certificate formData
                          setFormData(prev => ({
                              ...prev,
                              cert_patient_name: patient.lab_reg_name || "",
                              cert_guardien: patient.lab_guardian_name || "",   // guardian name field DB me jo hoga uske hisaab se
                              cert_gender: patient.lab_reg_gender || "Male",
                              cert_address: patient.lab_reg_address || "",
                              cert_city: patient.lab_reg_city || "",
                              cert_state: patient.lab_reg_state || "",
                              cert_mobile: patient.lab_reg_mobile || patient.ipd_patient_mobile ||  "",
                              cert_doctor: patient.lab_reg_referral || patient.ipd_refer_doctor || "", // agar doctor referral se aa raha hai
                              cert_ipd_number: patient.lab_reg_uhid || "", // UHID confirm karne ke liye
                          }));
          
                          toast.success("Patient details loaded");
                      } else {
                          toast.error("No patient found with this UHID");
                      }
                  } else {
                      toast.error(response.data.message || "No patient found");
                  }
              } catch (error) {
                  console.error("Search Error:", error);
                  toast.error("Error fetching patient details");
              }
          };
          
          
            function getDoctorNameById(id) {
            const doctor = formData.doc.find(doc => doc.user_id === String(id));
            return doctor ? doctor.fname : " Enter Refer Doctor";
          }
          
          
              const fetchConfigData = async () => {
                  try {
                    const res = await axios.post(
                      `${AppConst.BASE_URL + AppConst.getconfig}?config_type=lab`
                    );
              
                    if (res.data.status) {
                      const data = res.data;
              // console.log("Config Data:", JSON.stringify(data.header_logo));
                      setImage(data.header_logo);
                      setWatermarkImage(data.logo || ''); // Set watermark image if available
                      setFooterImage(data.footer_logo || ''); // Set watermark image if available
                 
                  } 
              }
                  catch (err) {
                    console.error("Error fetching config:", err);
                  }
                };
              
                useEffect(() => {
                  fetchConfigData()
                }, [formData]);
               
          
                // Helper function to format date as DD-MM-YYYY
          const formatDate = (dateString) => {
            if (!dateString) return "";
            try {
              const date = new Date(dateString);
              return `${String(date.getDate()).padStart(2, '0')}-${String(date.getMonth() + 1).padStart(2, '0')}-${date.getFullYear()}`;
            } catch (e) {
              return dateString;
            }
          };
          
          
          const imageUrlToBase64 = async (url) => {
              // Check if the URL is valid
              if (!url) {
                  console.error("imageUrlToBase64: Provided URL is empty or invalid.");
                  return null;
              }
          
              // NEW: Added detailed logging to debug image loading issues.
              // console.log("Attempting to fetch image from URL:", url);
          
              try {
                  const response = await fetch(url, { cache: 'no-cache' }); // Added no-cache to prevent browser caching issues
                  if (!response.ok) {
                      console.error(`Failed to fetch image. URL: ${url}, Status: ${response.status} ${response.statusText}`);
                      return null;
                  }
                  
                  const blob = await response.blob();
              
                  if (!blob.type.startsWith('image/')) {
                      console.error(`The URL did not point to an image. URL: ${url}, MIME Type: ${blob.type}`);
                      return null;
                  }
              
                  return new Promise((resolve, reject) => {
                      const reader = new FileReader();
                      reader.onloadend = () => resolve(reader.result);
                      reader.onerror = (error) => {
                          console.error("FileReader error:", error);
                          reject(error);
                      };
                      reader.readAsDataURL(blob);
                  });
              } catch (error) {
                  // This error often happens due to CORS (Cross-Origin Resource Sharing) policy.
                  // Make sure your server allows images to be fetched from the domain where this script is running.
                  console.error("Error fetching or converting image. This might be a CORS issue.", { url, error });
                  return null;
              }
          };
      const generateDeathCertificatePDF = async (certData) => {
    if (!certData) {
        toast.error("Certificate data is missing!");
        return;
    }

    const doc = new jsPDF("p", "mm", "a4");
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const leftMargin = 20;
    const rightMargin = pageWidth - 20;
    let y = 30;

    // === Decorative Border (Double Line) ===
    doc.setDrawColor(0);
    doc.setLineWidth(1.5);
    doc.rect(10, 10, pageWidth - 20, pageHeight - 20, "S");
    doc.setLineWidth(0.5);
    doc.rect(12, 12, pageWidth - 24, pageHeight - 24, "S");

    // === Header Full Width ===
    if (image) {
        const headerImgBase64 = await imageUrlToBase64(image);
        if (headerImgBase64) {
            doc.addImage(headerImgBase64, "PNG", 10, 10, pageWidth - 20, 25);
        }
    }
    y = 55;

    // === Title ===
    doc.setFontSize(22);
    doc.setFont("times", "bold");
    doc.setTextColor(150, 0, 0); // dark red
    doc.text("DEATH CERTIFICATE", pageWidth / 2, y, { align: "center" });
    doc.setTextColor(0, 0, 0);
    y += 20;

    // === Certificate Number ===
    doc.setFontSize(12);
    doc.setFont("helvetica", "italic");
    doc.text(`Certificate No: ${certData.cert_id || "_____________"}`, leftMargin, y);
    y += 15;

    // === Details Section ===
    doc.setFontSize(13);
    doc.setFont("helvetica", "normal");

    const details = [
        ["Deceased's Name", certData.cert_patient_name || "______________________"],
        ["Father/Spouse", certData.cert_guardien || "______________________"],
        ["Date of Death", certData.cert_dod ? formatDate(certData.cert_dod) : "____/____/______"],
        ["Place of Death", `${certData.cert_address || ""}, ${certData.cert_city || ""}, ${certData.cert_state || ""} - ${certData.cert_pincode || ""}`]
    ];

    details.forEach(([label, value]) => {
        doc.setFont("helvetica", "bold");
        doc.text(`${label}:`, leftMargin, y);
        doc.setFont("helvetica", "normal");
        doc.text(value, leftMargin + 60, y); // aligned values
        y += 12;
    });

    y += 20;

    // === Declaration (Special Format) ===
    const issuedDate = certData.cert_issued ? formatDate(certData.cert_issued) : formatDate(new Date());
    doc.setFont("times", "italic");
    doc.setFontSize(12);

    const declarationText = `This certificate is issued under the authority of the Registrar of Births and Deaths, confirming that the death of the person named above has been duly registered on ${issuedDate}.`;

    const splitDeclaration = doc.splitTextToSize(declarationText, pageWidth - 60);
    splitDeclaration.forEach((line) => {
        doc.text(line, pageWidth / 2, y, { align: "center" });
        y += 8;
    });

    y += 20;

    // === Signature Section ===
    const signatureBlockX = pageWidth / 2 + 10;
    doc.line(signatureBlockX, y, rightMargin, y);
    y += 10;

    doc.setFont("helvetica", "bold");
    doc.text("Registrar / Doctor", signatureBlockX, y);
    y += 8;

    doc.setFont("helvetica", "normal");
    doc.text(` ${getDoctorNameById(certData.cert_doctor) || "________________"}`, signatureBlockX, y);
    y += 8;
    doc.text("Official Seal / Stamp", signatureBlockX, y);

    // === Footer Full Width ===
    if (footerImage) {
        const footerImgBase64 = await imageUrlToBase64(footerImage);
        if (footerImgBase64) {
            doc.addImage(footerImgBase64, "PNG", 10, pageHeight - 25, pageWidth - 20, 15);
        }
    }

    // === Open PDF ===
    const pdfBlobUrl = doc.output("bloburl");
    window.open(pdfBlobUrl, "_blank");
};

              useEffect(() => {
  // Aaj ki date YYYY-MM-DD format me convert karni hogi
  const today = new Date().toISOString().split("T")[0];

  setFormData(prev => ({
    ...prev,
    cert_dod: today,
  }));
}, []);
          
    return (
        <div class="page-content">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-xxl-12">
                        <div class="card">
                            <div class="card-body">
                                <h5>Death Certificate</h5>
                                <br />
                                <div class="live-preview">
                                    <form onSubmit={handleSubmit}>
                                        <div class="row">

                                            <div class="col-md-4">
                                                <div >
                                                    <label for="customername-field" class="form-label">DC Number</label>
                                                    <input name="cert_dc_number" onChange={handleChange} value={formData.cert_dc_number} class="form-control" placeholder="Enter DC Number" type="text" readOnly style={{background: "#eeeeee"}}/>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div >
                                                    <label for="customername-field" class="form-label">DOD</label>
                                                    <input name="cert_dod" onChange={handleChange} value={formData.cert_dod} class="form-control" placeholder="Enter DOD" type="text"  required/>
                                                </div>
                                            </div>
                                           <div class="col-md-2">
                                                <div >
                                                    <label for="customername-field" class="form-label">Uhid Number</label>
                                                    <input name="cert_ipd_number" onChange={handleChange} value={formData.cert_ipd_number} class="form-control" placeholder="Enter UHID Number" type="text"  required/>
                                                </div>
                                                
                                            </div>
                                            <div class="col-md-2">
                                                 <button id="searchbtn" onClick={() => {
                                                    searchUserNow()
                                                }} type="button" class="btn btn-success" style={{width: "150px", marginTop: "32px",}}>
                                                    <i class="ri-search-line align-bottom me-1"></i> Search </button>
                                            </div>
                                            <div class="col-md-4">
                                                <div >
                                                    <label for="customername-field" class="form-label">Patient Name</label>
                                                    <input name="cert_patient_name" onChange={handleChange} value={formData.cert_patient_name} class="form-control" placeholder="Enter Patient Name" type="text"  required/>
                                                </div>
                                            </div>

                                            <div class="col-md-4">
                                                <div >
                                                    <label for="customername-field" class="form-label">Guardien</label>
                                                    <input name="cert_guardien" onChange={handleChange} value={formData.cert_guardien} class="form-control" placeholder="Enter Guardien" type="text"  required/>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div >
                                                    <label for="customername-field" class="form-label">Address</label>
                                                    <input name="cert_address" onChange={handleChange} value={formData.cert_address} class="form-control" placeholder="Enter Address" type="text"  required/>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div >
                                                    <label for="customername-field" class="form-label">City</label>
                                                    <input name="cert_city" onChange={handleChange} value={formData.cert_city} class="form-control" placeholder="Enter City" type="text"  required/>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div >
                                                    <label for="customername-field" class="form-label">State</label>
                                                    <input name="cert_state" onChange={handleChange} value={formData.cert_state} class="form-control" placeholder="Enter State" type="text"  required/>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div >
                                                    <label for="customername-field" class="form-label">Pincode</label>
                                                    <input name="cert_pincode" onChange={handleChange} value={formData.cert_pincode} class="form-control" placeholder="Enter Pincode" type="text"  required/>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div >
                                                    <label for="customername-field" class="form-label">Doctor</label>
                                                    <input name="cert_doctor" onChange={handleChange} value={getDoctorNameById(formData.cert_doctor)} class="form-control" placeholder="Enter Doctor" type="text"  required/>
                                                </div>
                                            </div>
                                             <div class="col-md-4">
                                                <div >
                                                    <label for="customername-field" class="form-label">Mobile Number</label>
                                                    <input name="cert_mobile" onChange={handleChange} value={formData.cert_mobile} class="form-control" placeholder="Enter Mobile Number" type="number"  required/>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div >
                                                    <label for="customername-field" class="form-label">Issued</label>
                                                    <input name="cert_issued" onChange={handleChange} value={formData.cert_issued} class="form-control" placeholder="Enter Issued" type="text"  required/>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div >
                                                    <label for="customername-field" class="form-label">Case</label>
                                                    <textarea name="cert_case" onChange={handleChange} value={formData.cert_case} class="form-control" placeholder="Enter Case"
                                                     required></textarea>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div >
                                                    <label for="customername-field" class="form-label">Attandent</label>
                                                    <textarea name="cert_attandant" onChange={handleChange} value={formData.cert_attandant} class="form-control" placeholder="Enter Attandent"
                                                     required></textarea>
                                                </div>
                                            </div>


                                            <div class="col-md-12">
                                                <br /><br />
                                            </div>

                                            <div class="col-lg-12">
                                                <div class="text-end">
                                                    <button type="submit" class="btn btn-primary">Save</button>
                                                    &nbsp;&nbsp;&nbsp;
                                                    <button type="button" class="btn btn-dark" onClick={() => generateDeathCertificatePDF(formData)}>Print</button>
                                                </div>
                                            </div>
                                        </div>

                                    </form>
                                </div>

                            </div>
                        </div>
                        <br />
                        <div class="card">
                        <div class="card-body pt-0">
                            <div>

                                <div class="table-responsive table-card mb-1">
                                    <table class="table table-nowrap align-middle" id="orderTable">
                                        <thead class="text-muted table-light" >
                                            <tr class="text-uppercase">
                                                <th scope="col">
                                                    <div class="form-check">
                                                        <input class="form-check-input" id="checkAll" type="checkbox" value="option" />
                                                    </div>
                                                </th>
                                                <th data-sort="customer_name"></th>
                                                <th data-sort="customer_name">Sr. No.</th>
                                                <th data-sort="customer_name">Patient</th>
                                                <th data-sort="customer_name">DC Number</th>
                                                <th data-sort="customer_name">Address</th>
                                                <th data-sort="customer_name">Mobile</th>
                                                <th data-sort="customer_name">Doctor</th>
                                                <th data-sort="city">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody class="list form-check-all">
                                            {formData.l1.map((item, index) => (
                                                <tr>
                                                    <th scope="row">
                                                        <div class="form-check">
                                                            <input class="form-check-input" type="checkbox" value="option1" name="checkAll" />
                                                        </div>
                                                    </th>
                                                                                                                         <td>
                                                          <div className="position-relative z-index-dropdown-fix">
            <button
              className="btn btn-link text-muted p-0"
              type="button"
              onClick={() => {
                if (dropdownOpenIndex === index) {
                  setDropdownOpenIndex(null); // close if already open
                } else {
                  setDropdownOpenIndex(index); // open current dropdown
                }
              }}
            >
              <i className="ri-more-2-fill fs-18"></i>
            </button>

            {dropdownOpenIndex === index && (
              <ul
                className="dropdown-menu dropdown-menu-end shadow show"
                style={{ position: "absolute", bottom: "100%", left: 0 }}
              >
                <li>
                  <button
                    className="dropdown-item"
                    onClick={ async () => {
                      setShowModal(true);
                      setDropdownOpenIndex(null);
                     generateDeathCertificatePDF(item);
                    }}
                  >
                    Print
                  </button>
                </li>
              </ul>
            )}
          </div>
        </td>
                                                    <td class="customer_name">{index + 1}</td>
                                                    <td class="product_name">{item.cert_patient_name}</td>
                                                    <td class="product_name">{item.cert_dc_number}</td>
                                                    <td class="product_name">{item.cert_address}, {item.cert_city}, {item.cert_state}, {item.cert_pincode}</td>
                                                    <td class="product_name">{item.cert_mobile}</td>
                                                    <td class="product_name">{item.cert_doctor}</td>
                                                    <td>
                                                        <ul class="list-inline hstack gap-2 mb-0">
                                                            <li class="list-inline-item edit" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" aria-label="Edit" data-bs-original-title="Edit">
                                                                <button
                                                                     disabled={!isAdmin} // ❌ normal user ke liye disable
                                                         style={{ opacity: !isAdmin ? 0.5 : 1, pointerEvents: !isAdmin ? "none" : "auto" }}
                                                                 onClick={(e) => {
                                                                    e.preventDefault();
                                                                    setEditItem(item);
                                                                    // document.getElementById("addbt453").click();
                                                                }} class="text-primary d-inline-block edit-item-btn btn btn-outline-primary">
                                                                    <i class="ri-pencil-fill fs-16"></i> Edit
                                                                </button>
                                                            </li>
                                                            <li class="list-inline-item" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" aria-label="Remove" data-bs-original-title="Remove">
                                                                <button
                                                                 class="text-danger d-inline-block remove-item-btn btn btn-outline-danger" 
                                                                      disabled={!isAdmin} // ❌ normal user ke liye disable
                                                         style={{ opacity: !isAdmin ? 0.5 : 1, pointerEvents: !isAdmin ? "none" : "auto" }}
                                                                 onClick={(e) => {
                                                                    e.preventDefault();
                                                                    delItem(item);
                                                                }}>
                                                                    <i class="ri-delete-bin-5-fill fs-16"></i> Delete
                                                                </button>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                            ))}

                                        </tbody>
                                    </table>
                                    {/* <div class="noresult">
                        <div class="text-center">
                          <lord-icon src="https://cdn.lordicon.com/msoeawqm.json" trigger="loop" colors="primary:#405189,secondary:#0ab39c"></lord-icon>
                          <h5 class="mt-2">Sorry! No Result Found</h5>
                          <p class="text-muted">We've searched more than 150+ Orders We did not find any orders for you search.</p>
                        </div>
                      </div> */}
                                </div>
                                <div class="d-flex justify-content-end">
                                    <div class="pagination-wrap hstack gap-2">
                                        <a class="page-item pagination-prev disabled" href="javascript:void(0)"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                if (formData.page_no > 0) {
                                                    formData.page_no--;
                                                    initData();
                                                }
                                            }}
                                        >Previous</a>
                                        <ul class="pagination listjs-pagination mb-0"></ul>
                                        <a class="page-item pagination-next" href="javascript:void(0)"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                formData.page_no++;
                                                initData();
                                            }}
                                        >Next</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DeathCert;
